export const checkHost = (host: string) => {
    const u = window.location.href;
    const reHost = new RegExp(`^http:\/\/(\d.\d.\d.\d|${host})`);
    return !!u.match(reHost);
};

export const isProductionHost = () => {
    return checkHost('login.foreflight.com');
};
